'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormCondition', ['$scope', 'ApplicationTypes', '$stateParams', '$q', 'FBConditions', 'FBQuestions', 'Triggers', '$injector', '$filter', '$state', '$timeout',
        function ($scope, ApplicationTypes, $stateParams, $q, FBConditions, FBQuestions, Triggers, $injector, $filter, $state, $timeout) {
        $scope.resetForm();
        $scope.conditionID = $stateParams.conditionID;
        $scope.questions = [];
        $scope.triggers = [];
        $scope.saving = false;
        $scope.loading = true;
        $scope.parameters = { condition_id: $stateParams.conditionID };
        var serviceOptions = {};
        $scope.messages = [];

        var promises = [];

        if ($stateParams.formID != null) {
            // Get Condition
            if ($stateParams.conditionID != null) {
                promises.push(FBConditions.getByID($stateParams.conditionID).then(function (condition) {
                    if (condition != null && condition.question_criteria != null && condition.question_criteria.length == 0) {
                        condition.question_criteria = [{ id: guid(), question_id: null, Sort_Order: 1 }];
                    }
                    $scope.condition = condition;
                }));
            }
            else {
                $scope.condition = { name: '', form_id: $stateParams.formID, description: null, trigger_id: null, question_criteria: [{ id: guid(), question_id: null, Sort_Order: 1 }] };
            }
            // Get Questions
            promises.push(FBQuestions.get({ formID: $stateParams.formID }).then(function (questions) {
                $scope.questions = questions;
                $scope.questions.forEach(function(question) {
                    question.group = question.page + ': ' + question.section;
                });
            }));
            // Get Triggers
            promises.push(Triggers.getForFormCondition().then(function (triggers) {
                triggers.unshift({ id: "00000000-0000-0000-0000-000000000000", name: "-- New Trigger --" });
                $scope.triggers = triggers;
            }));

        }

        $q.all(promises).then(function () {
            serviceOptions = {};
            $scope.condition.question_criteria.forEach(function (criterion) {
                $scope.questionChange($filter('filter')($scope.questions, { id: criterion.question_id })[0], criterion, true);
            });
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        function doParenthesesMatch(conditions) {
            var parenthesisString = '';
            for (var i = 0; i < conditions.length; i++) {
                var left = "", right = "";
                if (conditions[i].left_parenthesis === undefined) {
                    left = '';
                }
                else if (conditions[i].left_parenthesis == 1) {
                    left = "(";
                }
                else if (conditions[i].left_parenthesis == 2) {
                    left = "((";
                }
                if (conditions[i].right_parenthesis === undefined) {
                    right = '';
                }
                else if (conditions[i].right_parenthesis == 1) {
                    right = ")";
                }
                else if (conditions[i].right_parenthesis == 2) {
                    right = "))";
                }
                parenthesisString += left + right;
            }
            var parenthesisStack = [];
            for (var i = 0; i < parenthesisString.length; i++) {
                var char = parenthesisStack[parenthesisStack.length - 1];
                if (parenthesisString.charAt(i) == "(") {
                    parenthesisStack.push(parenthesisString.charAt(i));
                } else if (char == "(" && parenthesisString.charAt(i) == ")") {
                    parenthesisStack.pop();
                } else {
                    return false;
                }
            }

            window.scrollTo(0, 0);
            return (parenthesisStack.length) ? false : true;
        }

        $scope.save = function () {
            $scope.saving = true;
            $scope.messages = [];

            if (!doParenthesesMatch($scope.condition.question_criteria)) {
                $scope.messages.push('Validation failed! Please ensure parenthesis are valid.');
                $scope.saving = false;
                return false;
            }

            FBConditions.save($scope.condition).then(function (condition) {
                $scope.saving = false;
                $scope.loading = true;

                if (condition != null) {
                    $scope.condition = condition;
                    serviceOptions = {};
                    $scope.condition.question_criteria.forEach(function (criterion) {
                        $scope.questionChange($filter('filter')($scope.questions, { id: criterion.question_id })[0], criterion, true);
                    });
                }

                // Refresh Triggers
                Triggers.getForFormCondition().then(function (triggers) {
                    $scope.triggers = triggers;
                    $scope.loading = false;
                });

            });
        }

        $scope.delete = function () {
            $scope.deleting = true;
            FBConditions.delete($scope.condition.id).then(function (data) {
                $scope.deleting = false;
                $state.go('internal.licensing.license.form.conditions', { formID: $stateParams.formID });
            });
        }

        $scope.andOrOptions = [
            { id: true, name: 'and' },
            { id: false, name: 'or' }
        ];
        $scope.leftParenOptions = [
            { id: 0, name: '' },
            { id: 1, name: '(' },
            { id: 2, name: '((' }
        ];
        $scope.rightParenOptions = [
            { id: 0, name: '' },
            { id: 1, name: ')' },
            { id: 2, name: '))' }
        ];

        $scope.questionChange = function (question, criteria, initial) {
            criteria.loading = true;
            if (question != null) {
                criteria.type = question.type;
                if (question.type == 'date') {
                    criteria.operators = [
                        { id: '=', name: '=' },
                        { id: '<>', name: '<>' },
                        { id: '>', name: '>' },
                        { id: '<', name: '<' }
                    ];
                }
                else {
                    criteria.operators = [
                        { id: '=', name: '=' },
                        { id: '<>', name: '<>' }
                    ];
                }

                criteria.options = [];
                criteria.selectValue = 'id';
                criteria.selectShow = 'name';

                if (!initial) {
                    criteria.value = null;
                }

                if (question.type == 'yesno') {
                    criteria.options = [
                        { id: true, name: 'Yes' },
                        { id: false, name: 'No' }
                    ];
                    criteria.loading = false;
                }
                else if (question.service != null) {
                    if (serviceOptions[criteria.question_id] == null) {
                        serviceOptions[criteria.question_id] = [];

                        var service = $injector.get(question.service);
                        if (question.method == null || question.method == 'search') {
                            question.method = 'get';
                        }

                        // DOUBLE CHECK IF THIS IS WANTED IN ALL CASES
                        // Also check if we want to pass in the licene id, but ONLY for questions where the license_category_id == license.license_category_id
                        if (question.license_category_id != null) {
                            $scope.parameters['license_category_id'] = question.license_category_id;
                            // used for license levels filter, we're taking advantage of scope inheritance here
                            if ($scope.license.license_category_id == question.license_category_id) {
                                $scope.parameters['license_id'] = $scope.license.id;
                            }
                        }

                        service[question.method](angular.copy($scope.parameters)).then(function (data) {
                            criteria.options = angular.copy(data);
                            $timeout(function () {
                                criteria.loading = false;
                            }, 0)                           

                            serviceOptions[criteria.question_id].forEach(function (c) {
                                c.options = data;
                                $timeout(function () {
                                    c.loading = false;
                                }, 0)
                            })
                            serviceOptions[criteria.question_id] = null;
                        });
                    }
                    else {
                        serviceOptions[criteria.question_id].push(criteria);
                    }
                }
                else if (question.type == 'application_type') {    
                    $scope.parameters['license_id'] = $scope.license.id;
                    ApplicationTypes.get($scope.parameters).then(function (types) {
                        types.forEach(function (type) {
                            criteria.options.push({ id: type.id, name: type.label });
                        });
                        criteria.loading = false;
                    });
                }
                else if (question.options != null) {
                    if (angular.isString(question.options)) {
                        question.options.split(',').forEach(function (value) {
                            criteria.options.push({ id: value.trim(), name: value.trim() });
                        })
                    }
                    else {
                        criteria.options = question.options;
                    }

                    criteria.loading = false;
                }
                else {
                    criteria.loading = false;
                }
            } else {
                criteria.loading = false;
            }
        }

        $scope.add = function (array, item) {
            var addedIdx = array.indexOf(item) + 1;
            array.splice(addedIdx, 0, { and_flag: true, left_parenthesis: 0, operator: '=', right_parenthesis: 0, sort_order: item.sort_order+1 });
            array = array.map(function (elem, idx) {
                if (idx > addedIdx) {
                    elem.sort_order = elem.sort_order + 1;
                }
                return elem;
            });
        }

        $scope.remove = function (array, item) {
            var removedIdx = array.indexOf(item);
            array.splice(removedIdx, 1);
            // really wish I had arrow functions from ES6 here
            array = array.map(function (elem, idx) {
                if (idx+1 > removedIdx) {
                    elem.sort_order = elem.sort_order - 1;
                }
                return elem;
            });
        }

        $scope.reorder = function (array, item) {
            if (item.sort_order == null || isNaN(item.sort_order)) return;
            
            // sort order should already be changed
            var copyArray = angular.copy(array);
            var oldIdx = array.indexOf(item);
            var newIdx = item.sort_order - 1;
            var splicedItem = copyArray.splice(oldIdx, 1).pop();
            if (item.sort_order = 1) splicedItem.and_flag = null; // 1st item should NOT have an and_flag property
            copyArray = copyArray.map(function (elem) {
                if (elem.sort_order - 1 >= oldIdx && elem.sort_order - 1 < newIdx) {
                    elem.sort_order = elem.sort_order - 1;
                }
                if (elem.sort_order - 1 < oldIdx && elem.sort_order - 1 >= newIdx) {
                    elem.sort_order = elem.sort_order + 1;
                }
                return elem;
            });
            copyArray.splice(newIdx, 0, splicedItem);
            $scope.condition.question_criteria = copyArray;
        }
    }])
;